import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import $ from 'jquery';
import AnnotationUtil from '../../queries/annotations/AnnotationUtil';
import CommentUtil from '../../util/CommentUtil';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import StringUtil from '../../util/StringUtil';
import { Annotation, AnnotationThread } from '../../autogenerated/ZoomBridge'; // eslint-disable-line
import TextareaSuggestions, { textareaSuggestionsProps } from '../../hoc/TextareaSuggestions';
import AtMentionUserNotification from '../../components/comments/AtMentionUserNotification';
import Dropdown from '../../common/Dropdown';
import StoreListener from '../../store/StoreListener';
import { COLLECTION_USERS, COMMENT_TEXT } from '../../store/Constants';
import Store from '../../store/Store';
import t from '../../i18n/I18n';
import { ThemeSetup } from '../../themes/ThemeSetup';

import '../assets/AddCommentFormStyle.css';
import { KeyCode } from '../../util/Constants';

const debug = require('../../debug/debug')('wc:comments:AddCommentForm');

const getTextarea = (component) => component.refs.textarea;
const getSuggestions = (component) => component.getSuggestions();
const getAcceptSuggestion = (component) => component.acceptSuggestion;
//const storeItems = [{ name: COLLECTION_USERS, defaultValue: [] }];

//@StoreListener(storeItems)
@TextareaSuggestions(getTextarea, getSuggestions, getAcceptSuggestion)
export default class AddCommentForm extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    comment: PropTypes.object.isRequired,
    global: PropTypes.bool,
    edit: PropTypes.bool,
    closeOnOutsideClick: PropTypes.bool,
    style: PropTypes.object,
    ...textareaSuggestionsProps
  };

  static defaultProps = {
    global: false,
    edit: false,
    closeOnOutsideClick: true,
    style: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      comment: this.props.comment,
      commentText: CommentUtil.getRootCommentText(this.props.comment) || Store.get(COMMENT_TEXT),
      foldComment: false,
      atMentions: [],
      changedCommentKind: ''
    };
    this.onAttachFile = this.onAttachFile.bind(this);
    this.onAttachFileClick = this.onAttachFileClick.bind(this);
    this.onDeleteFile = this.onDeleteFile.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onTextChange = this.onTextChange.bind(this);

    this.suggestions = this.getSuggestions();
  }

  componentDidMount() {
    this.refs.textarea.focus();
    setTimeout(() => this.listenClickOutside(), 0);
  }
  componentWillReceiveProps() {
    this.setState({ comment: this.props.comment });
  }
  componentWillUnmount() {
    document.body.style.height = '100%';
    this.stopListeningClicksOutside();
  }

  getSuggestions = () => {
    return Store.get(COLLECTION_USERS, []).map((u) => ({
      value: u._userId,
      label: u._displayName || u._email,
      icon: ThumbnailUtil.avatar(u._userId)
    }));
  };

  listenClickOutside() {
    if (!this.props.closeOnOutsideClick) {
      return;
    }

    $('body').on('click.addcommentform', (event) => {
      if (this.state.commentText) {
        return;
      }

      if ($(event.target).parents('[name="TextareaSuggestions"]').length) {
        return;
      }

      if ($(event.target).parents('[name="Dropdown_List"]').length) {
        return;
      }

      if (!$(event.target).closest('#addCommentFormPosition').length) {
        this.props.onClose();
      }
    });
  }

  stopListeningClicksOutside() {
    $('body').off('click.addcommentform');
  }

  onAttachFileClick() {
    this.refs.fileInput.click();
  }

  onAttachFile(e) {
    const files = [...e.target.files];

    const comment = {
      ...this.state.comment,
      files: _.uniqBy(this.state.comment.files.concat(files), 'name')
    };

    this.setState({ comment });
  }

  onDeleteFile(file) {
    this.state.comment.files = _.without(this.state.comment.files, file);
    this.setState({ comment: this.state.comment });
  }

  drawAttachedFiles() {
    const styles = getStyle();
    return _.map(this.state.comment.files, (file, idx) => {
      return (
        <div key={idx} style={{ overflow: 'hidden', marginTop: '7px' }}>
          <div style={styles.fileName}>{file.name}</div>
          <div style={styles.deleteFile} onClick={() => this.onDeleteFile(file)} />
        </div>
      );
    });
  }

  onTextChange(event) {
    const { value } = event.target;
    const atMentions = this.getMentionedUsers(value);
    this.setState({ commentText: value, atMentions });
    this.props.onTextChange(event);
    Store.put(COMMENT_TEXT, value);
  }

  acceptSuggestion = (suggestion, text) => {
    const atMentions = this.getMentionedUsers(text);
    this.setState({ commentText: text, atMentions });
  };

  getMentionedUsers(comment) {
    const usersArray = StringUtil.parseTextForAtMentions(comment, this.suggestions);
    const atMentions = this.suggestions.filter((user) => usersArray.indexOf(user.label) > -1);
    return atMentions;
  }

  onSubmit() {
    if (!this.state.commentText) {
      debug('[onSubmit()] text is empty. return.');
      return this.onClose();
    }
    const text = this.state.commentText.trim();
    if (!text) {
      debug('[onSubmit()] text is empty. return.');
      return this.onClose();
    }
    const isKindChanged =
      this.state.changedCommentKind &&
      this.state.changedCommentKind !== AnnotationUtil.getAnnotationKind(this.state.comment);

    const annotationsThread: AnnotationThread = _.cloneDeep(this.state.comment);
    if (CommentUtil.getRootCommentText(annotationsThread) !== text || isKindChanged) {
      debug('[onSubmit()] no change in comment text or kind. return.');
      if (isKindChanged) {
        annotationsThread.setAnnotationKind(this.state.changedCommentKind);
      }

      let atMentions = [];
      if (this.state.atMentions.length > 0) {
        atMentions = this.state.atMentions.map((user) => user.label);
      }

      debug('[onSubmit()] atMentions: ', atMentions);
      const annotation: Annotation = AnnotationUtil.setRootReply(annotationsThread, this.state.commentText);
      annotation.setPeopleMentionedInTheComment(atMentions);
      this.props.onSubmit(annotationsThread);
    } else {
      return this.onClose();
    }
  }

  onClick = (e) => {
    e.stopPropagation();
  };

  // renderAtMentionInfo = () => {
  //   const { atMentions } = this.state;

  //   let emails;
  //   switch (atMentions.length) {
  //     case 0:
  //       return null;
  //     case 1:
  //       emails = atMentions[0];
  //       break;
  //     case 2:
  //       emails = `${atMentions[0]} and ${atMentions[1]}`;
  //       break;
  //     default:
  //       const first = atMentions.slice(0, atMentions.length - 1);
  //       const last = atMentions[atMentions.length - 1];
  //       emails = `${first.join(', ')}, and ${last}`;
  //   }

  //   return (
  //     <div style={styles.atMentions}>
  //       {emails} will be notified via email.
  //     </div>
  //   );
  // }

  render() {
    const { style } = this.props;
    const styles = getStyle();
    const { comment, atMentions } = this.state;
    const kind = this.state.changedCommentKind
      ? this.state.changedCommentKind
      : AnnotationUtil.getAnnotationKind(comment);

    const title = `${!this.props.edit ? t('NEW_COMMENT') : t('EDIT_COMMENT_CAPS')}`;
    return (
      <div
        name="AddCommentForm"
        id="addCommentFormPosition"
        style={{
          ...style,
          width: !this.props.global ? '340px' : '100%'
        }}
        onClick={this.onClick}>
        <div className="flex-row spc-between align-center">
          {/*<div style={ styles.attachFileIcon }*/}
          {/*onClick={ this.onAttachFileClick }*/}
          {/*/>*/}
          {/*<div style={ styles.attachFile }*/}
          {/*onClick={ this.onAttachFileClick }*/}
          {/*>ATTACH FILE</div>*/}
          {/*<input style={{ display: 'none' }} type="file" ref="fileInput" onChange={ this.onAttachFile } multiple />*/}
          <div style={styles.attachFile}>{title}</div>
          {this.props.edit ? null : (
            <Dropdown
              theme="PLAIN"
              listNodeName="AddCommentForm_Portal"
              value={kind}
              options={AnnotationUtil.getTypesOfAnnotation()}
              onChange={this.onTypeChange}
            />
          )}
        </div>
        {this.drawAttachedFiles()}
        <textarea
          value={this.state.commentText}
          onKeyDown={(e: KeyboardEvent)=>{ if(e.keyCode === KeyCode.ESCAPE)this.onClose()}}
          onChange={this.onTextChange}
          ref="textarea"
          style={{
            ...styles.textarea,
            display: 'block'
          }}
        />
        <AtMentionUserNotification atMentions={atMentions} />
        <div className="flex-row spc-between" style={styles.buttons}>
          <div onClick={() => this.onSubmit()} style={styles.save}>
            {t('SAVE')}
          </div>
          <div onClick={this.onClose} style={styles.cancel}>
            {t('CANCEL')}
          </div>
        </div>
      </div>
    );
  }

  onTypeChange = (type) => {
    this.setState({ changedCommentKind: type });
  };

  onClose = () => {
    Store.put(COMMENT_TEXT, '');
    this.props.onClose();
  };
}

function getStyle() {
  return {
    textarea: {
      width: '100%',
      height: '103px',
      border: '1px solid var(--separator-color)',
      boxShadow: 'none',
      marginTop: '12px',
      outline: 'none',
      resize: 'none',
      fontSize: '14px',
      color: 'var(--primary-font-color-selected)',
      backgroundColor: 'var(--primary-header-bg)'
    },
    save: {
      color: 'var(--primary-header-bg)',
      height: '30px',
      lineHeight: '30px',
      padding: '0 10px',
      cursor: 'pointer',
      background: 'var(--primary-style-color)',
      borderRadius: '2px',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '1px'
    },
    cancel: {
      height: '30px',
      lineHeight: '30px',
      cursor: 'pointer',
      color: 'var(--primary-font-color)',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '1px'
    },
    attachFileIcon: {
      display: 'inline-block',
      float: 'left',
      width: '12px',
      height: '12px',
      backgroundImage: 'url(images/attach_file.svg)',
      backgroundSize: '100%',
      marginRight: '8px',
      cursor: 'pointer'
    },
    attachFile: {
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '1px',
      color: 'var(--primary-style-color)',
      lineHeight: '13px',
      cursor: 'pointer'
    },
    foldCommentSection: {
      cursor: 'pointer'
    },
    comment: {
      display: 'inline-block',
      float: 'left',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '1px',
      color: 'var(--primary-style-color)',
      lineHeight: '13px'
    },
    fileName: {
      display: 'inline-block',
      float: 'left',
      width: '118px',
      marginRight: '5px',
      color: '#7A7A7A',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '1px',
      lineHeight: '15px',
      textTransform: 'uppercase',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },
    deleteFile: {
      float: 'left',
      width: '14px',
      height: '14px',
      backgroundImage: ThemeSetup.getBackgroundURL('delete_asset.svg'),
      backgroundSize: '100%'
    },
    buttons: {
      marginTop: 10
    },
    atMentions: {
      marginTop: 10,
      fontSize: 13,
      color: '#7a7a7a'
    }
  };
}
